const initialState = {
    isBackdropLoading: false,
    text: '',
};

const allLoaders = (state = initialState, action) => {
    switch (action.type) {

        case 'SET_BACKDROP_LOADING':
            return {...state, isBackdropLoading:  action.isLoading};
        
        case 'CHANGE_BACKDROP_LOADING_DATA':
            return {...state, isBackdropLoading:  action.isLoading, text: action.text};
            
        
        default:
            return state;
    }
};

export default allLoaders;
